import { FormControl, FormLabel } from 'material-ui/Form';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'material-ui/styles';
import ReactSlider from 'react-rangeslider';

import styles from '../../constants/styles';
import 'react-rangeslider/lib/index.css'

export const Slider = ({
  classes,
  label,
  value,
  onChange,
  unit = '',
  min,
  max,
  step,
  displayMultiplier = 1,
  precision = 1,
}) => {
  const displayValue = (value * displayMultiplier).toFixed(precision);
  const format = () => `${displayValue}${unit}`
  const legend = `${label}: ${displayValue}${unit}`

  return (
    <FormControl fullWidth className={classes.slider}>
      <FormLabel component="legend">{legend}</FormLabel>
      <ReactSlider
        min={min}
        max={max}
        value={value}
        step={step}
        onChange={onChange}
        format={format}
      />
    </FormControl>
  );
}

Slider.defaultProps = {
  displayMultiplier: undefined,
  precision: undefined,
  unit: undefined,
}

Slider.propTypes = {
  classes: PropTypes.shape({
    slider: PropTypes.string
  }).isRequired,
  label:   PropTypes.string.isRequired,
  value:   PropTypes.number.isRequired,
  onChange:PropTypes.func.isRequired,
  unit:    PropTypes.string,
  min:     PropTypes.number.isRequired,
  max:     PropTypes.number.isRequired,
  step:    PropTypes.number.isRequired,
  displayMultiplier: PropTypes.number,
  precision: PropTypes.number,
}

export default withStyles(styles)(Slider);



// WEBPACK FOOTER //
// ./src/components/common/Slider.js